import BaseApi from "../../BaseApi";

export class API extends BaseApi {
  constructor({ filterEntidades }) {

    super();

    this.site = scriptsData.siteUrl;

    this.defaultArgs = {
      order: 'ASC',
      orderby: 'menu_order'
    }

    if (filterEntidades !== 'null' && JSON.parse(filterEntidades).length) {
      this.defaultArgs['filterByTaxonomy'] = true;
      this.defaultArgs['terms'] = JSON.parse(filterEntidades);
    } else {
      this.defaultArgs['filterByTaxonomy'] = false;
    }

  }

  async loadContent(args) {

    const query = { ...args, ...this.defaultArgs };

    let queryString = new URLSearchParams(query).toString();
        queryString = queryString.length ? `?${queryString}` : '';

    const apiUrl = `${this.site}wp-json/wp/v2/get-entidades${queryString}`;
    const { data, totalPages } = await this.get(apiUrl);

    return { data, totalPages }

  }

}
